import { createReducer } from "typesafe-actions";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import NewRoutesCardConfiguration from "@app/types/dashboard/cards/newRoutes/NewRoutesCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  applyNewRoutesDrillDownListViewSettings,
  fetchNewRoutesCardDrillDownData,
  hideNewRoutesDrillDown,
  NewRoutesCardActions,
  showNewRoutesDrillDown,
} from "./actions";

export interface NewRoutesCardState {
  configuration?: NewRoutesCardConfiguration; // also works as a "visible" trigger, visible if set
  drillDownCustomDateRange?: DateRange;
  loading?: boolean;
  totalFilteredRoutes: number;
  totalRoutes: number;
  viewState: DrillDownViewState;
}

export const newRoutesInitialState: NewRoutesCardState = {
  totalFilteredRoutes: 0,
  totalRoutes: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const newRoutesState = createReducer<NewRoutesCardState, NewRoutesCardActions>(
  newRoutesInitialState
)
  .handleAction(showNewRoutesDrillDown.request, (state, { payload }) => ({
    ...state,
    configuration: payload.configuration,
    drillDownCustomDateRange: payload.customDateRange,
  }))
  .handleAction(showNewRoutesDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideNewRoutesDrillDown, (state) => ({
    ...state,
    configuration: undefined,
    drillDownCustomDateRange: undefined,
  }))
  .handleAction(fetchNewRoutesCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchNewRoutesCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRoutes: payload.totalFilteredRoutes,
    totalRoutes: payload.totalRoutes,
  }))
  .handleAction(fetchNewRoutesCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyNewRoutesDrillDownListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: {
      ...state.viewState,
      columns: payload.columns ?? state.viewState.columns,
      filter: payload.filter ?? state.viewState.filter,
      range: payload.range ?? state.viewState.range,
      sort: payload.sort ?? state.viewState.sort,
    },
  }));

export default newRoutesState;
